var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-steps-stepper" }, [
    _c("div", { staticClass: "rb-steps-stepper__container" }, [
      _c("div", { staticClass: "rb-steps-stepper__row" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rb-steps-stepper__circle",
          class:
            ((_obj = {}),
            (_obj["rb-steps-stepper__circle--" + _vm.color + " "] = _vm.color),
            _obj),
        },
        [_vm._t("icon")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rb-steps-stepper__row" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rb-steps-stepper__label" }, [_vm._t("label")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }